export default __webpack_public_path__ + "./images/gt.368c7788.png";